import { useSelector, shallowEqual } from 'react-redux'

import { formatters } from 'reactUtils/formatters'

import { Step } from '../../components/Step'
import { Title, Description } from '../../styled'

const ConcludeDesktop = ({ currentStep, customerSelected, price }) => {
  const { payload } = useSelector(state => state.user.get, shallowEqual)

  return (
    <Step step={3} currentStep={currentStep}>
      <Title withMargin>Tem certeza que deseja compartilhar esse cupom com {customerSelected && customerSelected.customerName} por <strong>{formatters.toDecimal(price)} pts?</strong></Title>

      <Description>
        Você gastará <strong>{formatters.toDecimal(price)} pontos</strong> para enviar esse cupom, seu cliente poderá ver o cupom enviado na seção <strong>Minhas vantagens</strong>, e avisaremos que esse cupom foi enviado por você.

        <br/>
        <br/>

        Seu Saldo atual é de <strong>{payload.points.actual} pts.</strong>
      </Description>
    </Step>
  )
}

export default ConcludeDesktop
